import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { AuthenticationGuard } from "./components/authentication-guard";
import { Route, Routes, Navigate } from "react-router-dom";
import { CallbackPage } from "./pages/callback-page";
import { HomePage } from "./pages/home-page";
import { LandingPage } from "./pages/landing-page";
import { NotFoundPage } from "./pages/not-found-page";
import { ProfilePage } from "./pages/profile-page";
import WorkoutsPage from "./pages/workouts-page";
import WorkoutDetailPage from "./pages/workout-detail-page";
import { ChatPage } from "./pages/chat-page";
import { ConnectPage } from "./pages/connect-page";
import { CalendarPage } from "./pages/calendar-page";
import { ApiKeysPage } from "./pages/api-keys-page";
import { DeveloperPage } from "./pages/developer-page";


const AuthAwareRouter = () => {
    const { isAuthenticated, isLoading } = useAuth0();
  
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    return (
      <Routes>
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/home" replace /> : <LandingPage />}
        />
        <Route
          path="/home"
          element={<AuthenticationGuard component={HomePage} />}
        />
        <Route
          path="/chat"
          element={<AuthenticationGuard component={ChatPage} />}
        />
        <Route
          path="/calendar"
          element={<AuthenticationGuard component={CalendarPage} />}
        />
        <Route
          path="/profile"
          element={<AuthenticationGuard component={ProfilePage} />}
        />
        <Route
          path="/connect"
          element={<AuthenticationGuard component={ConnectPage} />}
        />
        <Route
          path="/workouts"
          element={<AuthenticationGuard component={WorkoutsPage} />}
        />
        <Route
          path="/workouts/:workoutId"
          element={<AuthenticationGuard component={WorkoutDetailPage} />}
        />
        <Route
          path="/api-keys"
          element={<AuthenticationGuard component={ApiKeysPage} />}
        />
        <Route path="/developer" element={<DeveloperPage />} />
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  };
  
  export default AuthAwareRouter;